import { useState } from 'react';
import { LifeBuoy } from 'lucide-react';
import { TicketModal } from './TicketModal';

interface Props {
  /** Estilo do botão. 'topbar' para barra branca, 'portal' para topbar do portal */
  variant?: 'topbar' | 'portal';
  /** ID do cliente em contexto (opcional) */
  clientId?: string | null;
}

export function TicketButton({ variant = 'topbar', clientId }: Props) {
  const [open, setOpen] = useState(false);

  const className =
    variant === 'topbar'
      ? 'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:bg-secondary hover:text-foreground'
      : 'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-medium text-white/80 transition-colors hover:bg-white/10 hover:text-white';

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className={className}
        aria-label="Abrir chamado"
        title="Abrir chamado"
      >
        <LifeBuoy size={16} />
        <span className="hidden sm:inline">Chamado</span>
      </button>
      <TicketModal
        open={open}
        onOpenChange={setOpen}
        {...(clientId !== undefined && { clientId })}
      />
    </>
  );
}
